import { useEffect } from "react";
import { useAuthStore } from "@/features/auth/store/auth-store";
import { useChatStore } from "@/features/chat/store/chat-store";

/**
 * Opens the single shared chat WebSocket while at least one consumer is mounted
 * (ref-counted acquire/release, mirroring the announcements poll pattern). Mount
 * it once high in the authenticated tree (AppLayout) so unread badges and
 * new-message toasts work on every page, not just /chat.
 */
export function useChatSocket() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;
    const { acquire, release } = useChatStore.getState();
    acquire();
    return release;
  }, [isAuthenticated]);
}
